export default __webpack_public_path__ + "static/media/GasProjectReport.1049ae90.mrt";